import { MINIMUM_DNI_LENGTH } from './constants';

export const ADD_SUBSCRIBER = 'Agregar Solicitud';
export const SUBSCRIPTOR_LIST_TITLE = 'Solicitudes';
export const WARRANTY_LIST_TITLE = 'Tipo de garantía';
export const SERVICE_LIST_TITLE = 'Prestación';
export const USER_LIST_TITLE = 'Usuarios';
export const RISK_LIST_TITLE = 'Riesgo médico';
export const HEALTH_PLAN_LIST_TITLE = 'Tramo Plan de salud';
export const INSURANCE_LIST_TITLE = 'Previsión';
export const REGION_LIST_TITLE = 'Región';
export const COMMUNE_LIST_TITLE = 'Comuna';
export const LOG_LIST_TITLE = 'Visor de logs';
export const CREATION_TITLE = 'Creación';
export const EDITION_TITLE = 'Edición';
export const CHANGE_PASSWORD_TITLE = 'Cambiar contraseña';
export const PASSWORD_IS_NOT_THE_SAME_USER = 'La contraseña ingresada es incorrecta';

/** Forms */
export const SERVICE_FORM_TITLE = 'Antecedentes Prestación';
export const SUBSCRIBER_FORM_TITLE = 'Antecedentes del suscriptor';
export const ENDORSEMENT_FORM_TITLE = 'Antecedentes del aval';
export const PATIENT_FORM_TITLE = 'Información Paciente';
export const RESULT_TITLE = 'Resultado';
export const ADDRESS_NO_NORMALIZED = 'Dirección No pudo ser normalizada';

export const BUDGET_AMOUNT_LABEL = 'Monto Presupuesto';
export const DEPOSIT_AMOUNT_LABEL = 'Monto Abono';

export const SELECT_LABEL = '';
export const DNI_LABEL = 'DV';
export const NO_OPTION_LABELS = 'No hay opciones';
export const WAITING_OPTION_LABELS = 'Esperando opciones';

export const SUBSCRIPTOR_ADD_TITLE = 'Nueva Solicitud';
export const SUBSCRIPTOR_OK_BUTTON = 'Evaluar';

export const SAVE_EDITION_BUTTON = 'Guardar';
export const WARRANTY_TITLE = 'Edición';
export const SELECT_REGION_COMMUNE_SELECTOR = 'Debe ingresar Región';
export const TABLE_EMPTY_TABLE = 'No se encontraron resultados';

/** EndForms */

/** Validations texts */
export const INCORRECT_NEGATIVE_AMOUNT_TEXT = 'El monto tiene que ser mayor a 0';
export const INCORRECT_MINIMUN_DNI_CHARACTERS_TEXT = `El mínimo de caracteres tiene que ser ${MINIMUM_DNI_LENGTH}`;
export const INCORRECT_EMAIL_TEXT = 'Email ingresado inválido';
export const IS_REQUIRED_TEXT = 'El campo es requerido';
export const INCORRECT_CEDULA_TEXT = 'Número de Serie Cédula es incorrecto';
export const INCORRECT_PHONE_NUMBER = 'El número teléfonico es incorrecto';
export const INCORRECT_EQUAL_PHONE_NUMBER = 'Este número de teléfono debe ser distinto al anterior';
export const INCORRECT_CONFIRM_PASSWORD = 'Las contraseñas no coinciden, vuelva a intentarlo';
export const AMOUNT_IS_LOWER = 'Debe ser menor o igual a Monto Presupuesto';
export const SAME_AVAL_SUSCRIPTOR = 'El Aval debe ser distinto del Suscriptor';
export const ERROR_CHARACTERS_PASSWORD = 'Usa solo letras, números o signos de puntuación comunes';
export const INCORRECT_OLD_NEW_SAME_PASSWORD =
  'La nueva contraseña debe ser distinta a la anterior';
export const CREATED_USER =
  'Usuario creado exitosamente. Favor contactarse con Acepta para que sea registrado como operador';

export const INCORRECT_MINIMUM_CHARACTERS = minimum =>
  `El mínimo de caracteres tiene que ser ${minimum}`;

export const INCORRECT_MINIMUM_CHARACTERS_PASSWORD = minimum =>
  `Utilice ${minimum} caracteres como mínimo con una combinación de letras, números y símbolos`;
export const SERVER_ERROR =
  'Estimado usuario, ha ocurrido una incidencia, por favor contactar a soporte';

export const UNAUTHORIZED = 'Página no autorizada';
export const EMPTY_REASONS = 'Sin observaciones';
export const ERROR_NOT_COMPLETED = 'No Completado: Error 500';
export const RETRY_MESSAGE = '   Intente más tarde';

export const BEFORE_CREATED = 'El valor ingresado se encuentra creado';
export const LOGIN_PASS = 'Email y/o Contraseña inválidos';
export const MAX_LOGIN_ATTEMPTS_MESSAGE = 'Comuníquese con el administrador del sistema';
export const INCORRECT_VALUE = 'El valor ingresado es incorrecto';
export const CHANGES_SUCCESSFULL = 'Cambio realizado correctamente';

export const AUTENTIA_ERROR = 'Error de Autentia. Verifique rut operador';
export const OFFLINE_ERROR = 'No hay conexión. Compruebe la conexión y vuelva a intentarlo.';
export const AUTENTIA_INITIALIZING = 'Iniciando proceso';
export const AUTENTIA_MISSING_RUT = 'Es necesario ingresar el rut a consultar';
export const AUTENTIA_BUTTON_LABEL = 'Capturar Huella';

export const EXIST_RUT = 'rut already exists';

export const TRANSLATIONS = {
  "Can't undo. rut already exists": 'No se puede deshacer, rut ya existe'
};
